import { Flex } from '@chakra-ui/react'
import { DOCUMENT_LOCALIZATION } from 'entities/Documents/Documents.constants'
import { Field, FieldArray, Formik } from 'formik'
import { isEmpty } from 'lodash'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { TYPE_LOCALIZATION_MODEL } from 'shared/constants/localization'
import { Button, CheckboxForm, InputForm, SelectForm, TextAreaForm } from 'uikit'
import { Form, FormHeading, FormSection } from 'uikit/layout'
import * as Yup from 'yup'
import { styleTypeOptions } from '../../../Documents.constants'

const formSchema = Yup.object().shape({
  order: Yup.string().required('Обязательное поле'),
})

export const DocumentForm = ({ item = {}, loading = false, onSubmit }) => {
  const { id } = useParams()
  const isNew = !id
  const [activeIndex, setActiveIndex] = useState(0)

  const getInitialForm = () => {
    let documentCollection = []
    DOCUMENT_LOCALIZATION.forEach((lang) => {
      const nameItem = item?.names?.find((n) => n.localization === lang)
      const bodyItem = item?.bodies?.find((n) => n.localization === lang)
      documentCollection.push({
        name: !isEmpty(nameItem) ? nameItem.text : '',
        body: !isEmpty(bodyItem) ? bodyItem.text : '',
        idName: !isEmpty(nameItem) ? nameItem.id : 0,
        idBody: !isEmpty(bodyItem) ? bodyItem.id : 0,
        localization: lang,
      })
    })
    return documentCollection
  }

  const handleForm = async (values) => {
    onSubmit(values)
  }

  const onlyView = item.removed

  return (
    <Formik
      initialValues={{
        list: getInitialForm(),
        needUpdate: Boolean(item.needUpdate),
        publicAccess: Boolean(item.publicAccess),
        order: item.order !== undefined ? String(item.order) : '0',
        style: item?.style ? item?.style : '',
      }}
      enableReinitialize
      onSubmit={handleForm}
      validationSchema={formSchema}
    >
      {(props) => (
        <Form
          onSubmit={props.handleSubmit}
          footer={
            !onlyView && (
              <Button
                type="submit"
                colorPalette="orange"
                disabled={!props.isValid}
                loading={loading}
              >
                {isNew ? 'Создать' : 'Обновить'}
              </Button>
            )
          }
        >
          <FormSection>
            <Field
              name="style"
              component={SelectForm}
              label="Тип"
              placeholder="Выберите тип"
              options={styleTypeOptions}
              disabled={loading || onlyView}
            />

            <Flex mt="30px">
              <FieldArray
                name="list"
                render={() =>
                  props.values.list &&
                  props.values.list.length > 0 &&
                  props.values.list.map((friend, index) => (
                    <>
                      <Button
                        size="sm"
                        key={index}
                        colorPalette={activeIndex === index ? 'orange' : 'gray'}
                        onClick={() => setActiveIndex(index)}
                        mr={2}
                        disabled={loading}
                      >
                        {TYPE_LOCALIZATION_MODEL[friend.localization] || friend.localization}
                      </Button>
                    </>
                  ))
                }
              />
            </Flex>

            <Field
              name={`list[${activeIndex}].name`}
              component={InputForm}
              label="Название"
              disabled={loading || onlyView}
            />
            <Field
              name={`list[${activeIndex}].body`}
              component={TextAreaForm}
              minHeight="400px"
              label="Содержимое"
              disabled={loading || onlyView}
            />
          </FormSection>

          <FormSection>
            <FormHeading>Дополнительно</FormHeading>
            <Field
              type="number"
              name="order"
              component={InputForm}
              label="Сортировка"
              disabled={loading || onlyView}
            />
            <Field
              name="needUpdate"
              label="Поднять версию"
              component={CheckboxForm}
              disabled={loading || onlyView}
            />
            <Field
              name="publicAccess"
              label="Неавторизованная зона"
              component={CheckboxForm}
              disabled={loading || onlyView}
            />
          </FormSection>
        </Form>
      )}
    </Formik>
  )
}
